import { getBranchId, getHospitalId, getLoginID } from "../../../auth";
import FetchData from "../../client";

export const FetchCurrentStockByPharmacy = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    // inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData(
      "midoc_getpharmacycurrentstockreport",
      inputData
    );
    // console.log(result, "Medicine View Result");
    if (result.output) {
      // var finalOutput = formapimodalmedicinesPagination(result.output)
      // console.log(finalOutput, "finalOUTPUT");
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const FetchFilteredCurrentStockByPharmacy = async (inputData) => {
  try {
    // inputData.doctorid = getLoginID();
    // inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData(
      "midoc_getpharmacycurrentstockreport",
      inputData
    );
    // console.log(result, "Medicine View Result");
    if (result.output) {
      // var finalOutput = formapimodalmedicinesPagination(result.output)
      // console.log(finalOutput, "finalOUTPUT");
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
